/**
 * Loading Spinner Component
 * Reusable loading indicator with different sizes
 */

import { cn } from '@/lib/utils';

/**
 * LoadingSpinner Component
 * @param {Object} props - Component props
 * @param {string} props.size - Spinner size ('sm', 'md', 'lg')
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.text - Optional loading text
 */
const LoadingSpinner = ({ 
  size = 'md', 
  className = '', 
  text = '' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  return (
    <div className={cn(
      'flex items-center justify-center space-x-2',
      className
    )}>
      <div
        className={cn(
          'animate-spin rounded-full border-2 border-gray-300 border-t-blue-600',
          sizeClasses[size]
        )}
      />
      {text && (
        <span className={cn(
          'text-gray-600 font-medium',
          textSizeClasses[size]
        )}>
          {text}
        </span>
      )}
    </div>
  );
};

export default LoadingSpinner;